import React, { Component } from 'react';
import { connect } from 'react-redux';
import { redirect } from './redux/redirect';
import Router from './router';
import { useNavigate } from 'react-router-dom';

// Создаем HOC для передачи navigate
const withNavigation = (WrappedComponent) => (props) => {
    const navigate = useNavigate();
    return <WrappedComponent {...props} navigate={navigate} />;
};

class App extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.redirectTo && this.props.redirectTo !== prevProps.redirectTo) {
            this.props.navigate(this.props.redirectTo); // Используем navigate
            this.props.onRedirect();
        }
    }

    render() {
        return (
            <div className="App">
                <Router />
            </div>
        );
    }
}

export default connect(
    (state) => ({
        redirectTo: state.redirect.redirectTo,
    }),
    (dispatch) => ({
        onRedirect: () => dispatch(redirect()),
    })
)(withNavigation(App));
